/**
 * Section: Featured Product
 * ------------------------------------------------------------------------------
 * Using for the featured product for slider of Thumbnail and Slider
 *
 * @namespace ProductMedia
 */

class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.slides = this.querySelectorAll('.swiper-slide');
    this.selectors = {
      slider: '[data-slider]',
      thumbs: '[data-thumbs]',
    };
    this.settings = {
      elements: {
        slider: this.querySelector(this.selectors.slider),
        thumbs: this.querySelector(this.selectors.thumbs),
      },
      instances: {
        slider: null,
        thumbs: null,
      },
      options: {
        slider: {
          spaceBetween: 32,
          watchOverflow: true,
          /*
          * Make sure the main slider also aligns vertically if required
          */
        },
        thumbs: {
          slidesPerView: 'auto',
          spaceBetween: 12,
          direction: 'horizontal',
        },
      },
    };
    /*
    * Since direction is always vertical, no need to listen for resize events
    */
    window.removeEventListener('resize', this.debouncedResize);
  }

  connectedCallback() {
    this.init();
  }

  init() {
    if (!this.settings.elements.slider || !this.settings.elements.thumbs) {
      return;
    }
    this.settings.instances.thumbs = new Swiper(
      this.settings.elements.thumbs,
      this.settings.options.thumbs,
    );
    this.settings.options.slider.thumbs = {
      swiper: this.settings.instances.thumbs,
    };

    this.settings.instances.slider = new Swiper(
      this.settings.elements.slider,
      this.settings.options.slider,
    );
  }

  /*
  * Remove changeDirection method because direction is now fixed to 'vertical'
  */

  setActiveMedia(value) {
    const matches = Array.from(
      this.querySelectorAll(`img[alt="${value}"]`),
    ).map((img) => img.closest('.swiper-slide, .swiper-slide-hidden'));
    if (matches.length === 0) return;
    this.slides.forEach((slide) => {
      slide.classList.remove(
        'swiper-slide-active',
        'swiper-slide-next',
        'swiper-slide-prev',
        'swiper-slide-visible',
        'swiper-slide-thumb-active',
      );
      slide.classList.toggle('swiper-slide', matches.includes(slide));
      slide.classList.toggle('swiper-slide-hidden', !matches.includes(slide));
    });
    this.updateInstances();
  }

  updateInstances() {
    this.settings.instances.thumbs.update();
    this.settings.instances.slider.update();
    this.settings.instances.thumbs.slideTo(0);
    this.settings.instances.slider.slideTo(0);
  }
}

customElements.define('product-media', ProductMedia);
